// src/core/stadtwerteTop7.ts
// Marktdaten auf Stadtebene für die 7 größten Städte (Dominiks Entscheidung 18.10.2026:
// „Stadtwerte recherchieren“). standortDaten.json (PLZ-Ebene, Stand 01/2022) enthält diese
// Städte nicht. Quelle hier: immowelt, Angebotspreise Bestands-Eigentumswohnungen Q3 2026
// und immowelt Mietkompass (Angebotsmiete Bestandswohnung 75 m², 3 Zimmer, kalt), beide
// Stand 01.10.2026. Gröber als PLZ-Daten (ein Wert je Stadt) und eine andere Quelle/ein
// anderer Stand als der Rest – deshalb mit Quelle angezeigt. r = Miete × 12 / Kaufpreis.
export interface Stadtwert { k: number; m: number; r: number }

const sw = (k: number, m: number): Stadtwert => ({ k, m, r: Math.round(((m * 12) / k) * 10000) / 10000 });

export const STADTWERTE_TOP7: Record<string, Stadtwert> = {
  "München": sw(8035, 21.65),
  "Hamburg": sw(6010, 13.98),
  "Frankfurt am Main": sw(5585, 17.12),
  "Berlin": sw(5007, 14.63),
  "Köln": sw(4874, 13.9),
  "Düsseldorf": sw(4537, 14.18),
  "Stuttgart": sw(4311, 15.21),
};

export const STADTWERTE_QUELLE = "immowelt, Angebotspreise/-mieten Bestandswohnungen, Stand 01.10.2026";
